<template>
<ion-page id="blindfold-page">
    <ion-content>
      <div v-show="showState == SHOW_HISTORY">
        <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" 
            :style="styleHistory">
 
          <div v-show="showTour">
            <Tour  :tour="tourInfo" :tourTrigger="tourTrigger" @tour-done="tourDone" />
          </div>

          <div v-for="item in historyItems" v-bind:key="item.index">
            <div @click="onGameClick(item.index)" class="game-history-center-text">
              "{{  t("Game") }} {{ item.index+1 }}" {{ item.date }}
              <br>
              {{ item.color }}/{{ item.blindness }} {{ item.moves }} {{ t("Moves") }}
              <br>
              {{ item.engine }}({{ item.skill }}) {{ t("Result") }}={{ item.score }}
            </div>
            <hr>
          </div>
        </div>
      </div>
      <div v-show="showState == SHOW_ONE_GAME">
          <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" 
            :style="styleBoard">
          <CMChessboard :fen="fen"  :validMoves="availableMoves"
                  :animateOnePly="animateFen"
                  :orientation="orientation" 
                  :boardSize="boardSize" />
          </div>
          <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" 
            :style="styleMoveList">
            <GameReviewMoveList 
                      :gameId="gameId"
                      :directionClicked="directionClicked" 
                      :directionTrigger="directionTrigger"
              @move-list-click="moveListClick"
            ></GameReviewMoveList>
          </div>
        </div>

    </ion-content>
    <Toolbar id="the_toolbar" :elements="toolbarElements" :trigger="toolbarTrigger"
                          :ignoreClicks="showTour" @toolbar-click="toolbarClick" />
  </ion-page>
</template>

<script setup>

  import { IonIcon,IonPage, IonContent , modalController } from '@ionic/vue';

  import { availableWidthHeight, calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'

  import CMChessboard from '@/components/CMChessboard.vue'
  import GameReviewMoveList from '@/components/GameReviewMoveList.vue'
  import ModalErrorMessage from '@/components/ModalErrorMessage.vue'

  import { findValueString } from '@/composables/blindfoldSupport.js'

  import { findToolbarElement, setToolbarElementDisabledFlag, setToolbarElementLabel} 
                from '@/composables/toolbarSupport.js'
  import { ref, watch } from 'vue'
  import Toolbar from '@/components/Toolbar.vue'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';
  import { doStartupCheck } from '@/composables/startupCheck.js'
  import { useGetData , useGetDataDownload } from '@/composables/getData.js'
  import Tour from '@/components/Tour.vue'
  import { t , replaceMultipleAll } from '@/composables/translateText.js'

  const windowSizeStore = useWindowSizeStore()
  const noAvailableMovesFlag = ref(0)
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })

  const connectionStore = useConnectionStore()

  const isDark = ref(connectionStore.getDarkmode != "light")
  const menuTrigger = ref(0)

  const tourTrigger = ref(0)
  const tourOption = connectionStore.getTourOption
  //console.log("*** Tour option",tourOption)
  const showTour = ref((tourOption == "show"))

  const gameId = ref("")
  const boardSize = ref(300)
  var orientation = ref("white")
  const availableMoves = ref([])
  const INITIAL_FEN = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"
  const fen = ref(INITIAL_FEN)
  const animateFen = ref([])
  const directionClicked = ref("")
  const directionTrigger = ref(0)

  const blindfoldStrings = [t("Not Blind"),t("Not Blind"),"1 " + t("Color"),"2 " + t("Discs"),"1 " + t("Disc"),t("Empty")]
  const blindfoldValues = [ "0","1", "2", "3", "4", "5" ]

  const colorStrings = [t("White"), t("Black")]
  const colorValues = [ "1", "0" ]

  const SHOW_HISTORY = 0
  const SHOW_ONE_GAME = 1
  const SHOW_LOADING = 2
  const showState = ref(SHOW_LOADING)

  const TOOLBAR_DOWNLOAD_OR_DONE = 0
  const TOOLBAR_REWIND = 1
  const TOOLBAR_BACK = 2
  const TOOLBAR_NEXT = 3
  const TOOLBAR_LAST = 4

  const toolbarElements = ref([
    { index : TOOLBAR_DOWNLOAD_OR_DONE, label : t("Download Games") ,disabled : false},
    { index : TOOLBAR_REWIND, label : t("Rewind") ,disabled : true},
    { index : TOOLBAR_BACK, label : t("Back") ,disabled : true},
    { index : TOOLBAR_NEXT, label : t("Next") ,disabled : true},
    { index : TOOLBAR_LAST, label : t("Last") ,disabled : true}
  ])

  
  const toolbarTrigger = ref(0)

  const styleMoveList = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const styleBoard = ref({
    position : "absolute",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const styleHistory = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const historyItems = ref([])

   // tour stuff
   const tourInfo = ref({
    id : "game_history",
    video : "",
    elements : [
      { id: "", title: t("Game History"), text : t("A scrollable list of the last 99 games you've played against the computer or blindfold.<br><br>Clicking on a game takes you to the 'Review' screen.")},
      { id: "the_toolbar", title: t("Download - Toolbar"), text : t("Builds a PGN file of all the games you've played. You can import this into another game review program")}
    ]
  })

  doStartupCheck(false,afterStartupCallbackRoutine)

  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

  function afterStartupCallbackRoutine(stuffChanged,errorProgram,errorEntry) {
    if (errorProgram != null)
      openErrorModal(errorProgram,errorEntry)
    updateWidthHeights()
    getHistory()
    menuTrigger.value++
  }

  watch(() => windowSizeStore.getWindowSize, () => {
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    updateWidthHeights()
  })

  function updateStyleObjects(boundaries) {
    styleHistory.value.height = boundaries['history'].height + "px"
    styleHistory.value.width = boundaries['history'].width + "px"
    styleHistory.value.top = boundaries['history'].top + "px"
    styleHistory.value.left = boundaries['history'].left + "px"

    styleBoard.value.height = boardSize.value + "px"
    styleBoard.value.height = boundaries['board'].height + "px"
    styleBoard.value.width = boundaries['board'].width + "px"

    styleBoard.value.top = boundaries['board'].top + "px"
    styleBoard.value.left = boundaries['board'].left + "px"

    styleMoveList.value.height = boundaries['movelist'].height + "px"
    styleMoveList.value.width = boundaries['movelist'].width + "px"
    styleMoveList.value.top = boundaries['movelist'].top + "px"
    styleMoveList.value.left = boundaries['movelist'].left + "px"
  }

  function updateWidthHeights() {
    const availableSpace = availableWidthHeight()
    const isPortrait = isScreenPortraitOrientation(availableSpace)
    const boundaries = (isPortrait) ? calculatePortraitWidthHeights(availableSpace) :
                                      calculateLandscapeWidthHeights(availableSpace)
    
    updateStyleObjects(boundaries)
  }

  function calculatePortraitWidthHeights(availableSpace) {

    // reserve space for the instruction lines
    const availableSpaceForBoard = { width : availableSpace.width ,
                height : availableSpace.height /2,
                isPortrait : true }

    const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

    const boardHeight = boardDimensions.height
    const boardWidth = boardDimensions.width
    const boardPositionTop = boardDimensions.y
    const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

    const commentPositionTop = boardPositionTop + boardHeight
    const commentPositionLeft = availableSpace.leftRightIndent
    const commentWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const movelistPositionTop = boardPositionTop + boardHeight
    const movelistPositionLeft = availableSpace.leftRightIndent
    const movelistHeight = availableSpace.height - movelistPositionTop
    const movelistWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const historyPositionTop = 0
    const historyPositionLeft = availableSpace.leftRightIndent
    const historyHeight = availableSpace.height - historyPositionTop
    const historyWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const result = { board : {
        width : boardWidth,
        height : boardHeight,
        left : boardPositionLeft + availableSpace.leftIndent,
        top : boardPositionTop+ availableSpace.topIndent
      },
      movelist : {
        width : movelistWidth,
        height : movelistHeight,
        left : movelistPositionLeft + availableSpace.leftIndent,
        top : movelistPositionTop+ availableSpace.topIndent
      },
      history : {
        width : historyWidth,
        height : historyHeight,
        left : historyPositionLeft + availableSpace.leftIndent,
        top : historyPositionTop+ availableSpace.topIndent
      }
    }
    //console.log("board and movelist dimensions",result)
    return (result)
  }

  function calculateLandscapeWidthHeights(availableSpace) {

    // reserve space for the instruction lines
    const availableSpaceForBoard = { width : availableSpace.width /2,
                height : availableSpace.height ,
                isPortrait : false }
    const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

    const boardHeight = boardDimensions.height
    const boardWidth = boardDimensions.width
    const boardPositionTop = boardDimensions.y
    const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

    const movelistPositionTop = boardPositionTop
    const movelistPositionLeft = boardPositionLeft + boardWidth + availableSpace.leftRightIndent
    const movelistHeight = availableSpace.height
    const movelistWidth = availableSpace.width - movelistPositionLeft

    const historyPositionTop = 0
    const historyPositionLeft = availableSpace.leftRightIndent
    const historyHeight = availableSpace.height - historyPositionTop
    const historyWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const result = { board : {
        width : boardWidth,
        height : boardHeight,
        left : boardPositionLeft + availableSpace.leftIndent,
        top : boardPositionTop+ availableSpace.topIndent
      },
      movelist : {
        width : movelistWidth,
        height : movelistHeight,
        left : movelistPositionLeft + availableSpace.leftIndent,
        top : movelistPositionTop+ availableSpace.topIndent
      },
      history : {
        width : historyWidth,
        height : historyHeight,
        left : historyPositionLeft + availableSpace.leftIndent,
        top : historyPositionTop+ availableSpace.topIndent
      }
    }
    return (result)
  }

  function toolbarClick(arrayIndex) {
      switch (arrayIndex) {
        case TOOLBAR_DOWNLOAD_OR_DONE :
          if (showState.value == SHOW_HISTORY)
            getDownload()
          else {
            showState.value = SHOW_HISTORY
            setToolbarElementLabel(toolbarElements.value,TOOLBAR_DOWNLOAD_OR_DONE,t("Download Games"))
            toolbarTrigger.value++
          }
          break
        case TOOLBAR_REWIND :
          directionClicked.value = "rewind"
          directionTrigger.value++
          break
        case TOOLBAR_BACK :
          directionClicked.value = "back"
          directionTrigger.value++
          break
        case TOOLBAR_NEXT :
          directionClicked.value = "next"
          directionTrigger.value++
          break
        case TOOLBAR_LAST :
          directionClicked.value = "last"
          directionTrigger.value++
          break
      }
  }

  function moveListClick(moveListFen,rewindDisabled,lastDisabled) {
    //console.log("IN HISTORY ",fen,rewindDisabled,lastDisabled)

    if (moveListFen != "")
      fen.value = moveListFen

    toolbarElements.value[TOOLBAR_REWIND].disabled = rewindDisabled
    toolbarElements.value[TOOLBAR_BACK].disabled = rewindDisabled
    toolbarElements.value[TOOLBAR_NEXT].disabled = lastDisabled
    toolbarElements.value[TOOLBAR_LAST].disabled = lastDisabled
  }

  function onGameClick(index) {
    setToolbarElementLabel(toolbarElements.value,TOOLBAR_DOWNLOAD_OR_DONE,t("Done"))
    toolbarTrigger.value++
    gameId.value = historyItems.value[index].gameId
    orientation.value = historyItems.value[index].color.toLowerCase()
    showState.value = SHOW_ONE_GAME
  }

  function tourDone() {
    showTour.value = false
  }

  function processJsonResponse (json) {
    //console.log(" in game history callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    var gameCount = Math.floor(json["game_count"])

    const gameIds = json["id"].split("\t")
    const blindnesses = json["blindness"].split("\t")
    const moves = json["moves"].split("\t")
    const engines = json["engine"].split("\t")
    const skills = json["skills"].split("\t")
    const dates = json["date"].split("\t")
    const reveals = json["reveal"].split("\t")
    const colors = json["color"].split("\t")
    const scores = json["score"].split("\t")

    if (gameCount > 99)
      gameCount = 99;

    for (var i=0; i < gameCount; i++) {
      const oneGame = { index : i,
              gameId : gameIds[i],
              blindness : (blindnesses[i] == "") ? t("Not Blind") : 
                            findValueString(blindfoldStrings,blindfoldValues,blindnesses[i]),
              moves : moves[i],
              engine : engines[i],
              skill : skills[i],
              date : dates[i],
              reveal : reveals[i],
              color : findValueString(colorStrings,colorValues,colors[i]),
              score : scores[i]  
            }
      historyItems.value.push(oneGame)
    }

    showState.value = SHOW_HISTORY
  }
  
  function getHistory() {

    const timeNow = Math.floor(Date.now() / 1000)

    var formData = {
      time : timeNow
    }

    useGetData("chessvis_engine_history.php", formData, processJsonResponse)
  }

  function getDownload() {
    const timeNow = Math.floor(Date.now() / 1000)
    const formData = {
      time : timeNow
    }

    useGetDataDownload("chessvis_engine_pgn.php", formData)
  }

</script>

<style scoped>


.game-history-center-text {
  text-align: center;
  margin-bottom : 5px;
  margin-top : 5px;
}

.game-history-center-text:hover {
  background: #4c6ca0;
}

.repselector-heading-color {
  background: #4c6ca0;
  color : white;
}

.repselector-left-text {
  text-align: left;
  margin-bottom : 5px;
  margin-top : 5px;
}

</style>